import React, { useState } from 'react';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false); // Close mobile menu after clicking
  };

  return (
    <nav className="fixed w-full z-50 nav-blur bg-white bg-opacity-90 border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => scrollToSection('hero')} 
              className="text-2xl font-light tracking-wide cursor-pointer"
            >
              HOUSE OF KHOSIKHADI
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-12">
            <button 
              onClick={() => scrollToSection('who')} 
              className="text-gray-800 hover:text-black transition-colors duration-300"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-gray-800 hover:text-black transition-colors duration-300"
            >
              Botswalle
            </button>
            <button 
              onClick={() => scrollToSection('healing')} 
              className="text-gray-800 hover:text-black transition-colors duration-300"
            >
              Healing
            </button>
            <button 
              onClick={() => scrollToSection('art')} 
              className="text-gray-800 hover:text-black transition-colors duration-300"
            >
              Art
            </button>
            <button 
              onClick={() => scrollToSection('get-involved')} 
              className="px-6 py-2 border border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-colors duration-300"
            >
              Get Involved
            </button>
          </div>

          {/* Hamburger Menu Icon */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={toggleMobileMenu}
              className="text-gray-800 hover:text-black focus:outline-none"
            >
              <i className="fas fa-bars text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu md:hidden bg-white bg-opacity-90 ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="flex flex-col space-y-4 p-6">
            <button 
              onClick={() => scrollToSection('who')} 
              className="text-gray-800 hover:text-black transition-colors duration-300 text-left"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-gray-800 hover:text-black transition-colors duration-300 text-left"
            >
              Botswalle
            </button>
            <button 
              onClick={() => scrollToSection('healing')} 
              className="text-gray-800 hover:text-black transition-colors duration-300 text-left"
            >
              Healing
            </button>
            <button 
              onClick={() => scrollToSection('art')} 
              className="text-gray-800 hover:text-black transition-colors duration-300 text-left"
            >
              Art
            </button>
            <button 
              onClick={() => scrollToSection('get-involved')} 
              className="px-6 py-2 border border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-colors duration-300 text-left"
            >
              Get Involved
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;